export default __webpack_public_path__ + "static/media/01.54793862.jpg";